<template>
  <div class="min-h-screen">
    <!-- Sidebar - Show based on role permissions -->
    <Sidebar v-if="showSidebar" />

    <!-- Main Content Area -->
    <div
      :class="mainContentClasses"
      class="min-h-screen transition-all duration-300"
    >
      <!-- Header -->
      <Header />

      <!-- Page Content -->
      <main class="p-4 lg:p-6">
        <router-view v-slot="{ Component }">
          <Transition
            mode="out-in"
            enter-active-class="transition-all duration-200"
            leave-active-class="transition-all duration-200"
            enter-from-class="opacity-0 translate-y-2"
            leave-to-class="opacity-0 -translate-y-2"
          >
            <component :is="Component" />
          </Transition>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useSidebar } from '@/composables/useSidebar'
import { useAuthStore } from '@/stores/auth'
import Sidebar from '@/components/dashboard/Sidebar.vue'
import Header from '@/components/dashboard/Header.vue'

const { isOpen, isMinimized } = useSidebar()
const authStore = useAuthStore()

// Determine if sidebar should be shown based on role
const showSidebar = computed(() => {
  // Admin roles always see sidebar
  if (authStore.isAdmin) {
    return true
  }
  
  // For other roles, check if they have any sidebar items
  const allowedItems = authStore.allowedSidebarItems
  
  // If allowedItems is null, show all (admin-like behavior)
  // If it's an empty array, hide sidebar
  // If it has items, show sidebar
  if (allowedItems === null) return true
  return allowedItems.length > 0
})

const mainContentClasses = computed(() => {
  // If sidebar is hidden, no left margin needed
  if (!showSidebar.value) {
    return ''
  }

  if (!isOpen.value) {
    return ''
  }
  return isMinimized.value ? 'ml-16' : 'ml-64'
})
</script>
